/**
 * Attach Turnstile token to scheduler API request bodies
 */

import { TURNSTILE_TOKEN_FIELD } from '../../constants/turnstile.js'

/**
 * @param {Record<string, unknown>} body
 * @param {string | null | undefined} turnstileToken
 */
export function withTurnstileToken (body, turnstileToken) {
  if (!turnstileToken) {
    return body
  }
  return { ...body, [TURNSTILE_TOKEN_FIELD]: turnstileToken }
}
